import React from "react";
import ReactDOM from "react-dom";
import AppLoader from "@/ui/AppLoader/AppLoader"

import './styles/layout.css';
import './styles/map.css';
import './styles/react-datetime.css';
import './styles/splash-screen.css';

import i18n from "./i18n";

import * as dotenv from 'dotenv';

dotenv.config();

ReactDOM.render(<AppLoader/>, document.getElementById("root"));